// extracted by mini-css-extract-plugin
export var container = "HowWeWork-module--container--36060";
export var readMore = "HowWeWork-module--read-more--7bf64";
export var stages = "HowWeWork-module--stages--9f0ea";